import { render, staticRenderFns } from "./PermisoProvisionalCrear.vue?vue&type=template&id=35470ab2&"
import script from "./PermisoProvisionalCrear.vue?vue&type=script&lang=js&"
export * from "./PermisoProvisionalCrear.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports